'use strict';

namespace Core {

    /*
    * This is for cases where we have nested forms and we'd like to validate the nested form independently of its
    * parent form
    * "borrowed" from here: https://github.com/angular/angular.js/issues/5858
     */
    class IsolateForm implements ng.IDirective {
        restrict: string;
        require: string;

        constructor() {
            this.restrict = 'A';
            this.require = '?form';
        }

        link = (scope: ng.IScope,
                element: ng.IAugmentedJQuery,
                attrs: ng.IAttributes,
                controller: ng.IFormController) => {

            if (!controller) {
                return;
            }

            element.addClass('isolated-form');

            // Do a copy of the controller
            let copy :ng.IFormController = <ng.IFormController>{};
            angular.copy(controller, copy);

            // Get the parent of the form
            let parent = element.parent().controller('form');

            // Remove parent link to the controller
            parent.$removeControl(controller);

            // Replace form controller with a "isolated form"
            let isolatedFormCtrl = {
                $setValidity: function (validationToken, isValid, control) {
                    copy.$setValidity(validationToken, isValid, control);
                    parent.$setValidity(validationToken, true, controller);
                },
                $setDirty: function () {
                    element.removeClass('ng-pristine').addClass('ng-dirty');
                    controller.$dirty = true;
                    controller.$pristine = false;
                }
            };
            angular.extend(controller, isolatedFormCtrl);
        }

        static factory(): ng.IDirectiveFactory {
            const directive = () => new IsolateForm();
            directive.$inject = [];
            return directive;
        }

    }

    const TR = angular.module('TR');
    TR.directive('isolateForm', IsolateForm.factory());

}
